var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000011699(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1599,
    cy: 29.2,
    r: 28.8,
    fill: "url(#paint0_linear_610_246)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3491 42.9442C12.7026 42.179 12.1149 41.4138 11.5859 40.5897L22.8708 29.2295L11.5859 17.8692C12.1149 17.0452 12.7026 16.2211 13.3491 15.5148L27.0438 29.2295L13.3491 42.9442ZM10.0577 20.6357C9.64629 21.5775 9.29363 22.637 8.99976 23.6965L14.5247 29.2295L8.99976 34.7624C9.29363 35.8219 9.64629 36.8226 10.1165 37.8232L18.6977 29.2295L10.1165 20.6357H10.0577ZM29.1598 31.3485L15.4651 45.0632C16.2291 45.7106 16.9932 46.2993 17.8161 46.829L29.1598 35.5276L40.5034 46.8879C41.3263 46.3581 42.0904 45.7695 42.8545 45.122L29.1598 31.4073V31.3485ZM37.741 48.3005L29.1598 39.7068L20.5785 48.3005C21.5777 48.7126 22.5769 49.1246 23.6349 49.4189L29.1598 43.8859L34.6847 49.4189C35.7426 49.1246 36.7418 48.7714 37.741 48.3005ZM29.1598 27.1105L42.8545 13.3958C42.0904 12.7483 41.3263 12.1597 40.5034 11.6299L29.1598 22.9313L17.8161 11.6299C16.9932 12.1597 16.1704 12.7483 15.4651 13.3958L29.1598 27.1105ZM48.203 37.8232C48.6145 36.8226 49.0259 35.8219 49.3198 34.7624L43.7949 29.1706L49.3198 23.6376C49.0259 22.5781 48.6732 21.5775 48.203 20.5769L39.6218 29.1706L48.203 37.7644V37.8232ZM35.39 29.2295L46.7336 17.8692C46.2047 17.0452 45.6169 16.2211 44.9704 15.5148L31.2757 29.2295L44.9704 42.9442C45.6169 42.179 46.2047 41.4138 46.7336 40.5897L35.4487 29.2295H35.39ZM29.1598 18.7522L37.741 10.1584C36.7418 9.68751 35.7426 9.33435 34.6847 9.04004L29.1598 14.573L23.6349 9.04004C22.5769 9.33435 21.5777 9.68751 20.5785 10.1584L29.1598 18.7522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_610_246",
    x1: 7.55986,
    y1: 6.88002,
    x2: 43.5599,
    y2: 53.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6533FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1183E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.32,
    height: 40.32,
    fill: "white",
    transform: "translate(8.99976 9.04004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000011699);
export default __webpack_public_path__ + "static/media/Group 1000011699.ca6c74fabcd6e518a056c13452474d85.svg";
export { ForwardRef as ReactComponent };